export const OPEN_POPUP = 'OPEN_POPUP';
export const CLOSE_POPUP = 'CLOSE_POPUP';

export const PRINT_TICKET = 'PRINT_TICKET';
export const UPPER_SCREEN = 'UPPER_SCREEN';